<canvas>{{ chart }}</canvas>
